import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from '../components/LoginModal';
import SignUpModal from '../components/SignUpModal';
import './Home.css';

export default function Home() {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleFeatureClick = (route) => {
    if (user) {
      navigate(route);
    } else {
      setShowLogin(true);
    }
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <h1 className="hero-title">
          <span className="gradient-text">conneCT</span>
        </h1>
        <p className="hero-subtitle">Where Connecticut comes together</p>
        <p className="hero-description">
          A vibrant space for young adults in Connecticut to connect, share experiences,
          discover local events, and build meaningful relationships.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => setShowLogin(true)}>Get Started</button>
          <button className="btn btn-outline">Learn More</button>
        </div>
      </section>

      <div className="features-grid">
        <div className="feature-card" onClick={() => handleFeatureClick('/events')} style={{ cursor: 'pointer' }}>
          <div className="feature-icon">🌟</div>
          <h3>Discover Events</h3>
          <p>Find local gatherings, meetups, and activities happening near you</p>
        </div>
        <div className="feature-card" onClick={() => handleFeatureClick('/groups')} style={{ cursor: 'pointer' }}>
          <div className="feature-icon">👥</div>
          <h3>Join Groups</h3>
          <p>Connect with like-minded individuals who share your interests</p>
        </div>
        <div className="feature-card" onClick={() => handleFeatureClick('/local')} style={{ cursor: 'pointer' }}>
          <div className="feature-icon">💬</div>
          <h3>Stay Connected</h3>
          <p>Engage in conversations and build lasting friendships</p>
        </div>
      </div>

      <div className="info-banner">
        <p>
          This platform is actively growing. More features coming soon as we expand
          our community across Connecticut!
        </p>
      </div>

      <LoginModal 
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToSignup={() => setShowSignup(true)}
      />

      <SignUpModal 
        isOpen={showSignup}
        onClose={() => setShowSignup(false)}
      />
    </div>
  );
}
